export var isNotEmptyString = function isNotEmptyString(value) {
  return typeof value === 'string' && value !== '';
};
var isValidScreenTabId = function isValidScreenTabId(internalScreenTabs, id) {
  return isNotEmptyString(id) && internalScreenTabs.find(function (tab) {
    return tab.id === id;
  }) !== undefined;
};
var isValidScreenTabIsActive = function isValidScreenTabIsActive(isActive) {
  return typeof isActive === 'boolean' || typeof isActive === 'undefined';
};
var isValidScreenTabIsVisible = function isValidScreenTabIsVisible(isVisible) {
  return typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
};
var isValidScreenTabData = function isValidScreenTabData(internalScreenTabs, _ref) {
  var id = _ref.id,
    isVisible = _ref.isVisible,
    isActive = _ref.isActive;
  return isValidScreenTabId(internalScreenTabs, id) && isValidScreenTabIsVisible(isVisible) && isValidScreenTabIsActive(isActive);
};
var countNumberOfActiveScreenTabs = function countNumberOfActiveScreenTabs(acc, _ref2) {
  var isActive = _ref2.isActive;
  if (isValidScreenTabIsActive(isActive) && isActive) {
    return acc + 1;
  }
  return acc;
};
var countNumberOfHiddenActiveScreenTabs = function countNumberOfHiddenActiveScreenTabs(acc, _ref3) {
  var isActive = _ref3.isActive,
    isVisible = _ref3.isVisible;
  if (isValidScreenTabIsActive(isActive) && isActive && isValidScreenTabIsVisible(isVisible) && !isVisible) {
    return acc + 1;
  }
  return acc;
};

// takes a partial screenTabsArray from the iframe that has been validated and merges it with the internal state
export var screenTabsPublicToInternalTransformer = function screenTabsPublicToInternalTransformer(internalScreenTabs, screenTabsFromApp) {
  var _screenTabsInternalUp;
  var numberOfActiveScreenTabs = 0;
  var internalActiveScreenTabIndex = internalScreenTabs.findIndex(function (tab) {
    return tab.isActive === true;
  });
  var screenTabsInternalUpdated = internalScreenTabs.map(function (screenTabInternal) {
    var _screenTabFromApp$isV;
    var screenTabFromApp = screenTabsFromApp.find(function (tab) {
      return tab.id === screenTabInternal.id;
    });
    if (!screenTabFromApp) {
      return screenTabInternal;
    }
    numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
    return {
      id: screenTabInternal.id,
      isVisible: (_screenTabFromApp$isV = screenTabFromApp.isVisible) !== null && _screenTabFromApp$isV !== void 0 ? _screenTabFromApp$isV : true,
      isActive: screenTabFromApp.isActive
    };
  });

  // if no active tab is specified. default to the first
  if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof ((_screenTabsInternalUp = screenTabsInternalUpdated[0]) === null || _screenTabsInternalUp === void 0 ? void 0 : _screenTabsInternalUp.isActive) !== 'undefined') {
    screenTabsInternalUpdated[0].isActive = true;
  }
  return screenTabsInternalUpdated;
};

// checks that screenTabsFromApp can be transformed into the internal state
export var screenTabsPublicToInternalValidator = function screenTabsPublicToInternalValidator(internalScreenTabs, screenTabsFromApp // a partial screentabs data containing only changed tabs
) {
  if (!Array.isArray(screenTabsFromApp)) {
    return false;
  }
  var screenTabsFromAppFiltered = screenTabsFromApp.filter(function (data) {
    return isValidScreenTabData(internalScreenTabs, data);
  });
  var numberOfActiveScreenTabs = screenTabsFromApp.reduce(countNumberOfActiveScreenTabs, 0);
  var numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce(countNumberOfHiddenActiveScreenTabs, 0);
  return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};

// get validation errors when screenTabsFromApp cannot be transformed into the internal state
export var getScreenTabsPublicToInternalValidationErrors = function getScreenTabsPublicToInternalValidationErrors(internalScreenTabs, screenTabsFromApp // a partial screentabs data containing only changed tabs
) {
  if (!internalScreenTabs) {
    return ['There are no screen tabs in the current view.'];
  }
  if (!Array.isArray(screenTabsFromApp)) {
    return ['Your app must return screen tabs as an array.'];
  }
  var errors = [];
  if (screenTabsFromApp.reduce(countNumberOfActiveScreenTabs, 0) > 1) {
    errors.push('Only one screen tab can be in focus.');
  }
  if (screenTabsFromApp.reduce(countNumberOfHiddenActiveScreenTabs, 0) > 0) {
    errors.push("You can't hide a screen tab that's currently in focus.");
  }
  return errors;
};